import { DictType } from "@pma/types"
import { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "../common/popover"
import { Button } from "../common/button"
import useTranslator from "@pma/hooks/use-translator"
import { cn } from "@pma/utils/helpers"
import { List } from "lucide-react"
import { useAuth } from "@pma/stores/auth-store"
import { Avatar, AvatarImage } from "../common/avatar"

interface Props {
  workDiaryDetails: DictType
}

const WorkDiaryTask = ({ workDiaryDetails }: Props) => {
  const { authConfig } = useAuth()
  const { translate, locale } = useTranslator()
  const isHebrew = locale == "he" ? true : false
  const organizationUsers = authConfig?.organizationUsers || []

  const [openLogs, setOpenLogs] = useState(false)

  const RenderAssignTo = ({ user }: any) => {
    return (
      <Avatar className='mr-1 h-5 w-5'>
        <AvatarImage
          src={user?.user_picture?.url || `${process.env.PUBLIC_URL}/user-profile.svg`}
        />
      </Avatar>
    )
  }

  const handleFilterTask = () => {
    const arr = workDiaryDetails?._tasks.filter((task: any) => task?.finish_to == 1)
    return arr.length
  }

  return (
    <Popover open={openLogs} onOpenChange={setOpenLogs}>
      <PopoverTrigger asChild className='cursor-pointer'>
        <div
          className={cn("flex w-full cursor-pointer items-center gap-0", isHebrew ? "rtl" : "ltr")}
          onMouseEnter={() => setOpenLogs(true)}
          onMouseLeave={() => setOpenLogs(false)}
        >
          <Button
            variant={"ghost"}
            className='m-0 p-0 hover:bg-transparent'
            leftSection={<List size={16} className='mx-1 text-blue-600' />}
          >
            {`${handleFilterTask()}/${workDiaryDetails?._tasks?.length}`}
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent
        className={workDiaryDetails?._tasks?.length ? "w-full md:w-[400px]" : "hidden"}
      >
        <div>
          <h3 className='mb-3 border-b pb-2 text-lg font-bold'>{translate("Tasks")}:</h3>
          <ul className='space-y-2'>
            {workDiaryDetails?._tasks.map((task: any, index: number) => (
              <li key={`r_${index}`} className='flex items-center gap-2 text-gray-500'>
                <span className={cn("flex", task?.finish_to == 1 ? "line-through" : "")}>
                  <strong>{task?.description} - </strong>
                </span>
                <p className='ml-2 flex'>
                  {organizationUsers.map((user: any) => {
                    if (task.responsible_id.includes(user.id)) {
                      return <RenderAssignTo user={user} />
                    } else return null
                  })}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default WorkDiaryTask
